// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"b110ba0e","990":"142eebe9"}[chunkId] + ".chunk.js";
};